import Rest from '@/services/Rest'

export default class CategoryService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/categories'

}
